import React from 'react'
import {loadLazy as ll} from 'uix/parts'

export const ImportUpload = ll(() => import(/* webpackChunkName: 'imports' */ './upload'))
export const ImportDirectories = ll(() => import(/* webpackChunkName: 'imports' */ './directories'))
export const OaiHarvester = ll(() => import(/* webpackChunkName: 'imports' */ './harvester'))
export const ImportConfig = ll(() => import(/* webpackChunkName: 'imports' */ './config'))
export const ImportPackages = ll(() => import(/* webpackChunkName: 'imports' */ './reimport'))
